export enum ReportStatus {
  ONGOING,
  OKFINISHED,
  KOFINISHED,
  PENDING,
  KOEXCHANGE
}

export class SendReportView {
  constructor(
    public reportId: string,
    public emailsReport: string
  ) { }
}

export class BaseReportiew
{
  public reportId: string;
  public country: string;
  public airline: string;
  public status: ReportStatus;
  public fileName: string;
  public fileType: string;
  public filtersJson: string;
  public statusIcon: string;
  public statusString: string;
  public statusColor: string;
}

export class ReportView extends BaseReportiew
{
  public periodFrom: Date;
  public periodTo: Date;
  public initDate: Date;
  public endDate: Date;
  public currency: string;
  public createDate: Date;
}

export class VolumeReportView extends BaseReportiew
{
  public from: string;
  public to: string;
}
